<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="900px"
    :title="title || $l('INDEX.dialog_title_chooseTemplate') || '选择导出模版'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      ref="main"
      :templateGroup="templateQueryParams.templateGroup"
      @close="close"
      @confirm="confirm"
    />
  </el-dialog>
</template>
<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
import { request } from '@/api/service'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    templateQueryParams: {
      type: Object,
      default: () => ({ templateGroup: '' }),
    },
    exportOptions: {
      type: Object,
      default: () => ({ params: {}, checkMethod: 'POST', checkUrl: '' }),
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async confirm(e) {
      this.loadingOpen()
      if (!(await this.exportCheck(e))) return this.loadingClose()

      const { params } = this.exportOptions
      const { exportTaskName, customerExportTemplateCode } = e
      const res = await this.$api
        .SYS_EXPORT_TASK(exportTaskName, {
          customerExportTemplateCode,
          ...(params || {}),
        })
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (200 !== status) {
        this.$message.error(
          this.$l('INDEX.Description_Failed_to_add_export_task') ||
            '导出任务添加失败'
        )
        return
      }
      this.$message({
        message:
          this.$l('INDEX.added_to_the_download_center') ||
          '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
        type: 'success',
      })
      this.$emit('update:visible', false)
      this.$emit('export-success')
    },
    async exportCheck(e) {
      const { params, checkUrl, checkMethod = 'POST' } = this.exportOptions
      if (!checkUrl) return true
      const sendParams = { ...(params || {}), ...(e || {}) }
      const res = await request({
        url: checkUrl,
        method: checkMethod,
        data: checkMethod === 'POST' ? sendParams : null,
        params: checkMethod === 'GET' ? sendParams : null,
      }).catch(() => null)
      const { status } = res || {}
      return 200 === status
    },
  },
}
</script>
